import { render, staticRenderFns } from "./rList.vue?vue&type=template&id=9c7015c0"
import script from "./rList.vue?vue&type=script&lang=js"
export * from "./rList.vue?vue&type=script&lang=js"
import style0 from "./rList.vue?vue&type=style&index=0&id=9c7015c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports